export const transactionTemplate = {
  namespaced: true,
  state: {
    Header: {
      PrimaryLabel: "",
      SecondaryLabel: "",
      TertiaryLabel: "",
    },
    HeaderKey: 0,
  },
  actions: {
    async setLabels({ commit }, payload) {
      commit("SET_HEADER_LABELS", payload);
    },
    async setPrimaryLabel({ commit }, label) {
      commit("SET_PRIMARY_LABEL", label);
    },
    async setSecondaryLabel({ commit }, label) {
      commit("SET_SECONDARY_LABEL", label);
    },
    async setTertiaryLabel({ commit }, label) {
      commit("SET_TERTIARY_LABEL", label);
    },
  },
  mutations: {
    SET_HEADER_LABELS(state, payload) {
      state.Header.PrimaryLabel = payload.PrimaryLabel;
      state.Header.SecondaryLabel = payload.SecondaryLabel;
      state.Header.TertiaryLabel = payload.TertiaryLabel;
    },
    SET_PRIMARY_LABEL(state, payload) {
      state.Header.PrimaryLabel = payload;
      // state.HeaderKey++;
    },
    SET_SECONDARY_LABEL(state, payload) {
      state.Header.SecondaryLabel = payload;
      state.HeaderKey++;
    },
    SET_TERTIARY_LABEL(state, payload) {
      state.Header.TertiaryLabel = payload;
      state.HeaderKey++;
    },
  },
  getters: {
    getPrimaryLabel: (state) => {
      return state.Header.PrimaryLabel;
    },
    getSecondaryLabel: (state) => {
      return state.Header.SecondaryLabel;
    },
    getTertiaryLabel: (state) => {
      return state.Header.TertiaryLabel;
    },
    getHeaderKey: (state) => {
      return state.HeaderKey;
    },
  },
};
